import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { CheckMarkIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { LanguageTestAnswer as LanguageTestAnswerType } from '../../../lib/types/models/language-test/language-test-answer'

interface LanguageTestAnswerProps {
  answer: LanguageTestAnswerType
  index: number
}

const indexToLetter = (index: number) => {
  return String.fromCharCode(65 + index)
}

const LanguageTestAnswer = ({ answer, index }: LanguageTestAnswerProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between px-4 py-2.5 border border-grey-light rounded gap-4',
        answer.isCorrect && 'bg-green-light border-green-light-active'
      )}
    >
      <div className="flex items-baseline gap-2">
        <Typography variant="label-semibold" color={tailwindColors.grey.lighter}>
          {indexToLetter(index)}
        </Typography>
        <Typography variant="label-semibold" color={tailwindColors.grey.lighter}>
          -
        </Typography>
        <Typography variant="tag">{answer.label}</Typography>
      </div>

      {answer.isCorrect && (
        <div className="flex items-center gap-2">
          <CheckMarkIcon className="w-4 h-4" color={tailwindColors.green.DEFAULT} />
          <Typography variant="label-semibold" color={tailwindColors.green.DEFAULT}>
            Correct
          </Typography>
        </div>
      )}
    </div>
  )
}

export default LanguageTestAnswer
